__turbopack_context__.v({
  "amount": "PointHistory-module-scss-module__rBdZZa__amount",
  "amountEarn": "PointHistory-module-scss-module__rBdZZa__amountEarn",
  "amountUse": "PointHistory-module-scss-module__rBdZZa__amountUse",
  "arrow": "PointHistory-module-scss-module__rBdZZa__arrow",
  "arrowOpen": "PointHistory-module-scss-module__rBdZZa__arrowOpen",
  "balanceBadge": "PointHistory-module-scss-module__rBdZZa__balanceBadge",
  "balanceRow": "PointHistory-module-scss-module__rBdZZa__balanceRow",
  "date": "PointHistory-module-scss-module__rBdZZa__date",
  "desc": "PointHistory-module-scss-module__rBdZZa__desc",
  "earn": "PointHistory-module-scss-module__rBdZZa__earn",
  "empty": "PointHistory-module-scss-module__rBdZZa__empty",
  "list": "PointHistory-module-scss-module__rBdZZa__list",
  "panel": "PointHistory-module-scss-module__rBdZZa__panel",
  "row": "PointHistory-module-scss-module__rBdZZa__row",
  "rowLeft": "PointHistory-module-scss-module__rBdZZa__rowLeft",
  "rowRight": "PointHistory-module-scss-module__rBdZZa__rowRight",
  "shimmer": "PointHistory-module-scss-module__rBdZZa__shimmer",
  "skeleton": "PointHistory-module-scss-module__rBdZZa__skeleton",
  "toggle": "PointHistory-module-scss-module__rBdZZa__toggle",
  "toggleLabel": "PointHistory-module-scss-module__rBdZZa__toggleLabel",
  "typeBadge": "PointHistory-module-scss-module__rBdZZa__typeBadge",
  "use": "PointHistory-module-scss-module__rBdZZa__use",
  "wrap": "PointHistory-module-scss-module__rBdZZa__wrap",
});
